module.exports = __webpack_public_path__ + "img/6.d39f5719.png";